import React, {Component} from 'react';

class DeleteDialog extends Component {
    render() {
        return (
            <div>
                <div className="row modal-row">
                    <div className="col">
                        <input
                            className="form-control"
                            type="text"
                            value={ this.props.text }
                            disabled={true}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default DeleteDialog;


// WEBPACK FOOTER //
// ./src/components/dialogs/DeleteDialog.js